import { useState } from "react";
import { useEffect } from "react";

import Loader from "../../Loader/Loader";
import { useLocation, useNavigate } from "react-router";
import {
  blockunblock,
  orderdetails,
  userdetails,
  userdetailsmasterdata,
  refundOrderbyadmin,
  cancelOrder,
  reassignDriver,
} from "../../service/Mainservice";
import ChatComponent from "../Chat/ChatComponent";
import PushNotification from "../Notification/PushNotification";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const OrderDetails = () => {
  const [data, setData] = useState();
  const [mdata, setmData] = useState({});
  const [loading, setloading] = useState(true);
  const [showDriverModal, setShowDriverModal] = useState(false);
  const [drivers, setDrivers] = useState([]);

  const Navigate = useNavigate();
  const location = useLocation();

  const id = location.state?.id;

  useEffect(() => {
    if (id) {
      getData(id);
    } else {
      Navigate("/Orders");
    }
  }, []);

  const getData = async (id) => {
    try {
      const response = await orderdetails(id);
      setData(response.data?.data);
      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        Navigate("/");
      }
    }
  };
  const handleCancelOrder = async () => {
    try {
      const response = await cancelOrder(data?.id);
      getData(data?.id);
    } catch (err) {
      console.log(err);
    }
  };
  const handleReassignDriver = async (driverId) => {
    try {
      const response = await reassignDriver(data?.id, driverId);
      setShowDriverModal(false);
      getData(data?.id);
    } catch (err) {
      console.log(err);
    }
  };
  const handleRefundOrder = async () => {
    try {
      const response = await refundOrderbyadmin(data?.id, "Customer complaint");
      getData(data?.id);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="userdetails_container">
        {/* Header */}
        <div className="details_header">
          <button className="back_btn" onClick={() => Navigate("/Orders")}>
            ← Back to Orders
          </button>
          <h2>Order Details</h2>
        </div>

        <div className="userdetails">
          {data && (
            <>
              {/* ===========================================
              ORDER HEADER
          =========================================== */}
              <div className="order_header">
                <div>
                  <h2>Order #{data?.uniqueOrderId}</h2>

                  <p className="order_subtitle">
                    Order No :<strong> {data?.orderNumber}</strong>
                  </p>

                  <p className="order_subtitle">
                    Created : {new Date(data?.createdAt).toLocaleString()}
                  </p>
                </div>

                <div className="order_status_section">
                  <span
                    className={`status_badge status_${data?.orderStatus?.toLowerCase()}`}
                  >
                    {data?.orderStatus}
                  </span>

                  <p className="payment_method">
                    Payment :
                    <strong> {data?.paymentMethod?.toUpperCase()}</strong>
                  </p>

                  <p className="payment_method">
                    Status :<strong> {data?.paymentStatus}</strong>
                  </p>
                </div>
              </div>
              {/* ===========================================
                SUMMARY CARDS
          =========================================== */}
              <div className="summary_grid">
                {/* CUSTOMER */}

                <div className="summary_card2">
                  <h3>Customer</h3>
                  <div>
                    <p>
                      <strong>Name</strong>
                    </p>

                    <span>{data?.customer?.fullName}</span>
                  </div>
                  <p>
                    <strong>Email</strong>
                  </p>

                  <span>{data?.customer?.email}</span>

                  <p>
                    <strong>Phone</strong>
                  </p>

                  <span>{data?.customer?.mobilenumber}</span>
                </div>

                {/* STORE */}

                <div className="summary_card2">
                  <h3>Store</h3>

                  <p>
                    <strong>Shop</strong>
                  </p>

                  <span>{data?.vendor?.shopName}</span>

                  <p>
                    <strong>Owner</strong>
                  </p>

                  <span>{data?.vendor?.fullName}</span>

                  <p>
                    <strong>Address</strong>
                  </p>

                  <span>{data?.vendor?.address}</span>
                </div>

                {/* DRIVER */}

                <div className="summary_card2">
                  <h3>Driver</h3>

                  {data?.deliveryPerson ? (
                    <>
                      <p>
                        <strong>Name</strong>
                      </p>

                      <span>{data?.deliveryPerson?.fullName}</span>

                      <p>
                        <strong>Phone</strong>
                      </p>

                      <span>{data?.deliveryPerson?.mobilenumber}</span>
                    </>
                  ) : (
                    <div className="empty_state">Driver Not Assigned</div>
                  )}
                </div>

                {/* PAYMENT */}

                <div className="summary_card2">
                  <h3>Payment</h3>

                  <p>
                    <strong>Subtotal</strong>
                  </p>

                  <span>${data?.subTotal}</span>

                  <p>
                    <strong>Total</strong>
                  </p>

                  <span>${data?.totalPrice}</span>

                  <p>
                    <strong>Method</strong>
                  </p>

                  <span>{data?.paymentMethod}</span>
                </div>
              </div>
              {/* ===========================================
              ORDER ITEMS
          =========================================== */}
              <div className="details_grid">
                <div className="details_card">
                  <h3>Order Items</h3>

                  <div className="data_table_over">
                    <table className="data_table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product</th>
                          <th>Price</th>
                          <th>Qty</th>
                          <th>Total</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data?.products?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>

                            <td>{item.name}</td>

                            <td>${item.price}</td>

                            <td>{item.quantity}</td>

                            <td>
                              <strong>${item.totalPrice}</strong>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* ===========================
                ORDER TOTALS
            ============================ */}

                <div className="details_card">
                  <h3>Order Summary</h3>

                  <div className="price_row">
                    <span>Subtotal</span>
                    <strong>${data?.subTotal}</strong>
                  </div>

                  <div className="price_row">
                    <span>Delivery Fee</span>
                    <strong>${data?.deliveryFee}</strong>
                  </div>

                  <div className="price_row">
                    <span>Service Fee</span>
                    <strong>${data?.serviceFee}</strong>
                  </div>

                  <div className="price_row">
                    <span>Tax</span>
                    <strong>${data?.taxAmount}</strong>
                  </div>

                  <div className="price_row">
                    <span>Discount</span>
                    <strong>${data?.discountAmount}</strong>
                  </div>

                  <div className="price_row">
                    <span>Tip</span>
                    <strong>${data?.tipAmont}</strong>
                  </div>

                  <div className="price_total">
                    <span>Total Amount</span>

                    <strong>${data?.totalPrice}</strong>
                  </div>
                </div>
              </div>
              {/* ===========================================
                DELIVERY INFORMATION
          =========================================== */}
              <div className="details_grid">
                <div className="details_card">
                  <h3>Delivery Information</h3>

                  <div className="info_row">
                    <label>Delivery Type</label>

                    <span>{data?.OrderDeliveryType}</span>
                  </div>

                  <div className="info_row">
                    <label>Delivery Option</label>

                    <span>{data?.deliveryOption}</span>
                  </div>

                  <div className="info_row">
                    <label>Schedule</label>

                    <span>{data?.deliveryScheduleType}</span>
                  </div>

                  <div className="info_row">
                    <label>Pickup Schedule</label>

                    <span>{data?.pickupScheduleType}</span>
                  </div>

                  <div className="info_row">
                    <label>Pickup Code</label>

                    <span>{data?.pickupCode}</span>
                  </div>

                  <div className="info_row">
                    <label>Instructions</label>

                    <span>{data?.deliveryInstructions || "-"}</span>
                  </div>
                </div>

                {/* ===========================
                  ADDRESS
            ============================ */}

                <div className="details_card">
                  <h3>Delivery Address</h3>

                  <div className="address_box">
                    <p>
                      <strong>{data?.addressType}</strong>
                    </p>

                    <p>{data?.shippingAddress}</p>

                    <hr />

                    <p>
                      {data?.addressCity}, {data?.addressState}
                    </p>

                    <p>
                      {data?.addressPostal_code}, {data?.addressCountry}
                    </p>

                    <hr />

                    <p>
                      <strong>Latitude :</strong> {data?.latitude}
                    </p>

                    <p>
                      <strong>Longitude :</strong> {data?.longitude}
                    </p>
                  </div>
                </div>
              </div>{" "}
              {/* =========================
        ACTIONS PANEL
========================= */}
              <div className="details_card action_card">
                <h3>Order Actions</h3>

                <div className="action_grid">
                  {/* CANCEL ORDER */}

                  <button
                    className="action_btn danger"
                    onClick={() => handleCancelOrder()}
                  >
                    Cancel Order
                  </button>

                  {/* REFUND ORDER */}

                  <button
                    className="action_btn warning"
                    onClick={() => handleRefundOrder()}
                  >
                    Refund Order
                  </button>

                  {/* REASSIGN DRIVER */}

                  <button
                    className="action_btn primary"
                    onClick={() => setShowDriverModal(true)}
                  >
                    Reassign Driver
                  </button>

                  {/* CONTACT CUSTOMER */}

                  <button
                    className="action_btn info"
                    onClick={() =>
                      window.open(`tel:${data?.customer?.mobilenumber}`)
                    }
                  >
                    Contact Customer
                  </button>

                  {/* CONTACT STORE */}

                  <button
                    className="action_btn info"
                    onClick={() =>
                      window.open(`tel:${data?.vendor?.phone || ""}`)
                    }
                  >
                    Contact Store
                  </button>
                </div>
              </div>
              {/* ===========================================
                ORDER TIMELINE
          =========================================== */}
              <div className="details_card timeline_card">
                <h3>Order Timeline</h3>

                <div className="timeline">
                  {data?.timeline?.length > 0 ? (
                    data.timeline.map((item, index) => (
                      <div className="timeline_item" key={index}>
                        <div
                          className={`timeline_dot ${
                            item.completed ? "completed" : ""
                          }`}
                        />

                        <div className="timeline_content">
                          <h4>{item.title}</h4>

                          <p>{item.status}</p>

                          <span>{new Date(item.time).toLocaleString()}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="empty_state">No Timeline Available</div>
                  )}
                </div>
              </div>
              {/* ===========================================
  CHAT LOGS - NOW REAL-TIME
=========================================== */}
              {/* <div className="details_card">
                <h3>Messages with Customer</h3>
                {data?.customer?.id ? (
                  <ChatComponent
                    userId={data.customer.id}
                    userType="customer"
                  />
                ) : (
                  <div className="empty_state">Customer ID not available</div>
                )}
              </div> */}
              {/* ===========================================
                CHAT LOGS
          =========================================== */}
              <div className="details_card">
                <h3>Messages Between Parties</h3>

                {data?.chatLogs?.length > 0 ? (
                  data.chatLogs.map((chat, index) => (
                    <div className="chat_item" key={index}>
                      <div className="chat_header">
                        <strong>{chat.sender}</strong>

                        <span>→</span>

                        <strong>{chat.receiver}</strong>
                      </div>

                      <p>{chat.message}</p>

                      <small>{new Date(chat.time).toLocaleString()}</small>
                    </div>
                  ))
                ) : (
                  <div className="empty_state">No Messages</div>
                )}
              </div>
              {/* ===========================================
                PROOF OF DELIVERY
          =========================================== */}
              <div className="details_card">
                <h3>Proof of Delivery</h3>

                {data?.deliveryProofImage ? (
                  <img
                    src={data.deliveryProofImage}
                    alt="Delivery Proof"
                    className="delivery_proof"
                  />
                ) : (
                  <div className="empty_state">
                    No Proof of Delivery Available
                  </div>
                )}
              </div>
              {/* ===========================================
                LIVE TRACKING
          =========================================== */}
              <div className="details_card">
                <h3>Live Tracking</h3>

                {data?.liveTracking ? (
                  <div className="tracking_box">
                    <p>Driver Location Available</p>

                    <p>Latitude : {data.liveTracking.latitude}</p>

                    <p>Longitude : {data.liveTracking.longitude}</p>
                  </div>
                ) : (
                  <div className="empty_state">Live Tracking Not Available</div>
                )}
              </div>
              {/* ===========================================
                ADDITIONAL INFORMATION
          =========================================== */}
              <div className="details_card">
                <h3>Additional Information</h3>

                <div className="info_row">
                  <label>Vendor Payout</label>
                  <span>${data?.vendorPayout}</span>
                </div>

                <div className="info_row">
                  <label>Platform Profit</label>
                  <span>${data?.myProfit}</span>
                </div>

                <div className="info_row">
                  <label>Coupon Code</label>
                  <span>{data?.couponCode || "-"}</span>
                </div>

                <div className="info_row">
                  <label>Voucher Code</label>
                  <span>{data?.voucherCode || "-"}</span>
                </div>

                <div className="info_row">
                  <label>Voucher Applied</label>
                  <span>{data?.voucherApplied ? "Yes" : "No"}</span>
                </div>

                <div className="info_row">
                  <label>Reorder</label>
                  <span>{data?.isReorder ? "Yes" : "No"}</span>
                </div>

                <div className="info_row">
                  <label>OTP</label>
                  <span>{data?.otp || "-"}</span>
                </div>

                <div className="info_row">
                  <label>Payment Intent</label>
                  <span>{data?.paymentIntentId}</span>
                </div>
              </div>
            </>
          )}

          {loading && <Loader />}
        </div>
      </div>
      {showDriverModal && (
        <div className="modal_overlay">
          <div className="modal_box">
            <h3>Select Driver</h3>

            {drivers?.map((d) => (
              <div
                key={d.id}
                className="driver_row"
                onClick={() => handleReassignDriver(d.id)}
              >
                {d.name}
              </div>
            ))}

            <button
              className="close_btn"
              onClick={() => setShowDriverModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {data?.device_token && (
        <div className="user_notification">
          <PushNotification id={data.device_token} />
        </div>
      )}
    </>
  );
};

export default OrderDetails;
